import { tw } from "@careinfo/tailwind";
import { ColumnDef } from "@tanstack/react-table";
import { useNavigate } from "react-router-dom";
import APIS from "../../constant/Endpoint";
import { DeleteIcon } from "../../Icons/DeleteIcon";
import Button from "../Reusable/Button";
import DataTable from "../Reusable/Datatable";
import TableSearch from "../Reusable/Datatable/components/Search";
import NACell from "../Reusable/Datatable/NACell";
import SwitchButton from "../Reusable/SwitchButton";
import TableActionButton from "../Reusable/TableActionButton";

const ServiceInfo = ({
  handleDelete,
  isLoading,
  handleIsActive,
  handleIsMaintainStock,
  handleIsTaxable,
}) => {
  const navigate = useNavigate();

  const columns: ColumnDef<any, any>[] = [
    {
      accessorKey: "hs_code",
      header: "HS Code",
      cell: NACell,
    },
    // {
    //   accessorKey: "category.name",
    //   header: "Product Group",
    //   cell: NACell,
    // },
    {
      accessorKey: "name",
      header: "Service Name",
      cell: ({ row, getValue }: any) => {
        return <p className={tw`w-60`}>{getValue()}</p>;
      },
    },
    // {
    //   accessorKey: "unit.name",
    //   header: "Unit",
    //   cell: NACell,
    // },
    // {
    //   accessorKey: "opening_quantity",
    //   header: "Opening Quantity",
    //   cell: ({ getValue }: any) => <p>{getValue() ?? 0}</p>,
    // },
    // {
    //   accessorKey: "opening_rate",
    //   header: "Opening Rate",
    //   cell: ({ getValue }: any) => (
    //     <p>
    //       {getValue()
    //         ? getValue().toLocaleString("en-IN", {
    //             minimumFractionDigits: 2,
    //             maximumFractionDigits: 2,
    //           })
    //         : 0}
    //     </p>
    //   ),
    // },
    // {
    //   accessorKey: "opening_balance",
    //   header: "Opening Value",
    //   cell: ({ getValue }: any) => (
    //     <p>
    //       {getValue()
    //         ? getValue().toLocaleString("en-IN", {
    //             minimumFractionDigits: 2,
    //             maximumFractionDigits: 2,
    //           })
    //         : 0}
    //     </p>
    //   ),
    // },
    // {
    //   accessorKey: "is_maintain_stock",
    //   header: "Maintain Stock",
    //   cell: ({ row, getValue }: any) => (
    //     <SwitchButton
    //       id={row?.original?.id}
    //       value={getValue()}
    //       disabled={false}
    //       onChange={handleIsMaintainStock}
    //     />
    //   ),
    // },
    {
      accessorKey: "is_taxable",
      header: "Taxable",
      cell: ({ row, getValue }: any) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={handleIsTaxable}
        />
      ),
    },
    {
      accessorKey: "is_active",
      header: "Active",
      cell: ({ row, getValue }: any) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={handleIsActive}
        />
      ),
    },
    {
      accessorKey: "id",
      header: "Action",
      cell: ({ row, getValue }: any) => {
        return (
          <div className={tw`grid grid-cols-2 gap-x-4 items-center`}>
            <button type="button" className={tw`focus:outline-none`}>
              <TableActionButton editPath={`edit/${getValue()}`} />
            </button>
            <button
              type="button"
              className={tw`focus:outline-none w-6 h-6`}
              onClick={() => handleDelete(getValue())}
            >
              <DeleteIcon color={"var(--primary)"} />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <div className={tw`space-y-4 mt-4`}>
      <div className={tw` flex gap-x-2`}>
        <TableSearch />
        <div className={tw`w-32`}>
          <Button
            label="Add New "
            type="button"
            onClick={() => navigate("create")}
          />
        </div>
      </div>
      <DataTable
        columns={columns}
        queryKey={"inventory-info"}
        tableName="inventory"
        url={APIS.PRODUCT}
        params={{}}
        customSearch={true}
      />
    </div>
  );
};

export default ServiceInfo;
